angular.module('qkr').controller('analyticsController', ($scope, analyticsService) => {
    const vm = $scope;

    vm.chartData = [];

    vm.initMerchantAnalytics = function() {
        analyticsService.getCoreMetrics().then((promise) => {
            $.each(promise.data, (index, value) => {
                if (value.metric === 'activeUsersKPI') {
                    vm.activeUsers = value.kpiValue;
                }

                if (value.metric === 'transactionCountKPI') {
                    vm.transactionCount = value.kpiValue;
                }

                if (value.metric === 'totalSalesValueKPI') {
                    vm.totalSalesValue = value.kpiValue;
                }
            });
        });

        analyticsService.getChartData('TransactionValueOverTimePeriodChart').then((promise) => {
            vm.chartData = [];
            angular.forEach(promise.data.series[0].dataPoints, (key, value) => {
                vm.chartData.push({x: value, y: key});
            });
        });
    };
});



// WEBPACK FOOTER //
// ./src/controllers/analytics.controller.js